import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { ThunkDispatch } from '@reduxjs/toolkit';

import changeOrderDownloadReducer from './rfxportal/components/quoteCoFileDownload/downloadSlice';
import businessInfoReducer from './rfxportal/reducers/businessInfoSlice';
import businessReducer from './rfxportal/reducers/businessSlice';
import buyerViewPageReducer from './rfxportal/reducers/BuyerViewPageSlice';
import changeOrderCommentsReducer from './rfxportal/reducers/ChangeOrder/commentsSlice';
import changeOrderDetailViewReducer from './rfxportal/reducers/ChangeOrder/detailViewSlice';
import changeOrderWizardReducer from './rfxportal/reducers/ChangeOrder/wizardSlice';
import createContactReducer from './rfxportal/reducers/CreateContactSlice';
import getUsersForBusinessEntityIdReducer from './rfxportal/reducers/GetUsersForBusinessEntityIdSlice';
import offerPageReducer from './rfxportal/reducers/OfferPageSlice';
import quoteStepReducer from './rfxportal/reducers/QuoteStepSlice';
import searchRFXRequestReducer from './rfxportal/reducers/RequestDashboardSlice';
import rfiBuyerDetailViewReducer from './rfxportal/reducers/rfiBuyerDetailViewSlice';
import rfiSupplierDetailViewReducer from './rfxportal/reducers/rfiSupplierDetailViewSlice';
import rfiWizardReducer from './rfxportal/reducers/rfiWizardSlice';
import rfxInformationReducer from './rfxportal/reducers/RFXInformationSlice';
import rfxRequestBackendModelReducer from './rfxportal/reducers/RFXReqBackendModelSlice';
import rfxRequestDocumentStepReducer from './rfxportal/reducers/RFXRequestDocumentStepSlice';
import manageRFXRequestReducer from './rfxportal/reducers/RFXRequestFormSlice';
import rfxRequestWizardReducer from './rfxportal/reducers/RFXRequestWizardSlice';
import manageRFXResponseReducer from './rfxportal/reducers/RFXResponseFormSlice';
import rfxResponseUIReducer from './rfxportal/reducers/RFXResponseUISlice';
import rfxTableReducer from './rfxportal/reducers/RFXTableSlice';
import supplierEntriesReducer from './rfxportal/reducers/SupplierEntriesSlice';
import supplierViewPageReducer from './rfxportal/reducers/SupplierViewPageSlice';

const store = configureStore({
  reducer: {
    searchRFXRequest: searchRFXRequestReducer,
    buyerViewPage: buyerViewPageReducer,
    supplierViewPage: supplierViewPageReducer,
    manageRFXRequest: manageRFXRequestReducer,
    manageRFXResponse: manageRFXResponseReducer,
    rfxRequestBackendModel: rfxRequestBackendModelReducer,
    rfxRequestWizard: rfxRequestWizardReducer,
    manageSupplierEntries: supplierEntriesReducer,
    offerPage: offerPageReducer,
    business: businessReducer,
    businessInfo: businessInfoReducer,
    rfxResponseUI: rfxResponseUIReducer,
    quoteStep: quoteStepReducer,
    rfxRequestDocumentStep: rfxRequestDocumentStepReducer,
    rfxTable: rfxTableReducer,
    createContact: createContactReducer,
    rfxInformation: rfxInformationReducer,
    rfiWizard: rfiWizardReducer,
    getUsersForBusinessEntityId: getUsersForBusinessEntityIdReducer,
    rfiSupplierDetailView: rfiSupplierDetailViewReducer,
    rfiBuyerDetailView: rfiBuyerDetailViewReducer,
    changeOrderWizard: changeOrderWizardReducer,
    changeOrderDetailView: changeOrderDetailViewReducer,
    changeOrderComments: changeOrderCommentsReducer,
    download: changeOrderDownloadReducer,
  },
  // TODO: clean up slice data, make sure all data are serializable, and remove this
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware({ serializableCheck: false })]
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, any> & typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
